export default __webpack_public_path__ + "static/media/m.profile1.8a90f6ab.jpeg";